import * as Switch from '@radix-ui/react-switch'

type Props = {
    /** Whether the setting is on */
    checked: boolean
    /** Called with the new state when the user toggles the switch */
    onCheckedChange: (checked: boolean) => void
    /** Optional data test id, used for testing */
    'data-test'?: string
}

/**
 * A switch turns a setting on or off and takes effect immediately, with no submit step. The component is controlled:
 * pass `checked` and update it in `onCheckedChange`. For a choice that is submitted with a form, use AstraCheckbox.
 *
 * @summary for an on/off setting that applies immediately
 */
export const AstraSwitch = ({ checked, onCheckedChange, 'data-test': dataTest }: Props) => (
    <Switch.Root
        checked={checked}
        onCheckedChange={onCheckedChange}
        className={`relative h-4 w-7 rounded-full transition-colors ${checked ? 'bg-brand-strong-selected' : 'bg-neutral-strong-rest/50'}`}
    >
        <Switch.Thumb
            data-test={dataTest}
            className={`block h-[14px] w-[14px] rounded-full bg-surface-base transition-transform will-change-transform ${checked ? 'translate-x-[13px]' : 'translate-x-[1px]'}`}
        />
    </Switch.Root>
)
